/* eslint-disable no-undef */
export const TRANSLATIONS = {
  BLACK_FRIDAY_URL: app_main_wpml.black_friday_url,
  BLACK_FRIDAY_CTA: app_main_wpml.black_friday_cta,
  BLACK_FRIDAY_CTA_MOBILE: app_main_wpml.black_friday_cta_mobile,
  XMAS_MODAL_TITLE: app_main_wpml.xmas_modal_title,
  XMAS_MODAL_CTA: app_main_wpml.xmas_modal_cta,
  XMAS_FEATURE_1: app_main_wpml.xmas_feature_1,
  XMAS_FEATURE_2: app_main_wpml.xmas_feature_2,
  XMAS_FEATURE_3: app_main_wpml.xmas_feature_3,
  PRODUCT_DIRECTORY: app_main_wpml.product_directory,
  CLOSE_TO_ME: app_main_wpml.close_to_me,
  WHAT_DO_YOU_WANT_TO_DO: app_main_wpml.what_do_you_want_to_do,
  RECENT_SEARCHES: app_main_wpml.recent_searches,
  DELETE_ALL: app_main_wpml.delete_all,
  NO_RESULT: app_main_wpml.no_result,
  NO_RESULTS_FOUND_FOR: app_main_wpml.no_results_found_for,
  MAKE_A_NEW_SEARCH: app_main_wpml.make_a_new_search,
  YOU_MIGHT_BE_INTERESTED: app_main_wpml.you_might_be_interested,
  REQUESTED_CATEGORIES: app_main_wpml.most_requested_categories,
  REQUESTED_EXPERIENCES: app_main_wpml.most_requested_experiences,
  NOVELTY: app_main_wpml.novelty,
  ACTIVE_FILTERS: app_main_wpml.active_filters,
  SHOW: app_main_wpml.show,
  ACTIVITIES: app_main_wpml.activities,
  N_PARTICIPANTS: app_main_wpml.n_participants,
  CATEGORIES: app_main_wpml.categories,
  SPAN: app_main_wpml.span,
  PRICE: app_main_wpml.price,
  ACTIVITY: app_main_wpml.activity,
  ALL_FILTERS: app_main_wpml.all_filters,
  REMOVE_FILTERS: app_main_wpml.remove_filters,
  APPLY_FILTERS: app_main_wpml.apply_filters,
  FILTER_REMOVE: app_main_wpml.filter_remove,
  STARTING_TIME: app_main_wpml.starting_time,
  CLOSE: app_main_wpml.close,
  APPLY: app_main_wpml.apply,
  REMOVE: app_main_wpml.remove,
  SEARCH_WHEN_PLACEHOLDER: app_main_wpml.search_when_placeholder,
  ALWAYS: app_main_wpml.always,
  TODAY: app_main_wpml.today,
  TOMORROW: app_main_wpml.tomorrow,
  AFTER_TOMORROW: app_main_wpml.after_tomorrow,
  NEXT_MONTH_FULL: app_main_wpml.next_month_full,
  HOURS: app_main_wpml.hours,
  MORE_DAYS: app_main_wpml.more_days,
  ALL: app_main_wpml.all,
  ALL_F: app_main_wpml.all_f,
  SEARCH_COUNT: app_main_wpml.search_count,
  SEARCH_COUNTS: app_main_wpml.search_counts,
  SHOW_MORE_ACTIVITIES: app_main_wpml.show_more_activities,
  FILTER: app_main_wpml.filter,
  PARTICIPANT: app_main_wpml.participant,
  PARTICIPANTS: app_main_wpml.participants,
  IMMEDIATE_CONFIRMATION: app_main_wpml.immediate_confirmation,
  INCLUDED_NIGHT: app_main_wpml.included_night,
  PRICEFROM: app_main_wpml.pricefrom,
  NOT_AVAILABLE: app_main_wpml.not_available,
  WE_HAVE_SEARCHED: app_main_wpml.we_have_searched,
  NO_ACTIVITY: app_main_wpml.no_activity,
  DISPLAY: app_main_wpml.display,
  DISTANCE_FROM_NEAREST: app_main_wpml.distance_from_nearest,
  DISTANCE: app_main_wpml.distance,
  DISTANCE_INFO: app_main_wpml.distance_info,
  DISTANCE_EXPANDED: app_main_wpml.distance_expanded,
  PRICE_FROM_LOWEST: app_main_wpml.price_from_lowest,
  PRICE_FROM_HIGHEST: app_main_wpml.price_from_highest,
  REMOVE_FILTER: app_main_wpml.remove_filter,
  ACTIVITY_TIPS: app_main_wpml.activity_tips,
  ACCESSIBILITY: app_main_wpml.accessibility,
  REMOVE_ALL_FILTERS: app_main_wpml.remove_all_filters,
  NO_FILTERS_SELECTED: app_main_wpml.no_filters_selected,
  FILTER_ORDER_BY: app_main_wpml.filter_order_by,
  ADD_DATES: app_main_wpml.add_dates,
  INSERT_REVIEW: app_main_wpml.insert_review,
  CONTACT_SEND: app_main_wpml.contact_send,
  SEND_REVIEW: app_main_wpml.send_review,
  OPTIONAL: app_main_wpml.optional,
  DESCRIPTION: app_main_wpml.description,
  TITLE: app_main_wpml.title,
  RATING: app_main_wpml.rating,
  GENERAL_RATING: app_main_wpml.general_rating,
  HOW_IT_WAS: app_main_wpml.how_it_was,
  CHOOSE_DATES: app_main_wpml.choose_dates,
  EXPERIENCE: app_main_wpml.experience,
  EXPERIENCES: app_main_wpml.experiences,
  SEARCH_WHERE_PLACEHOLDER: app_main_wpml.search_where_placeholder,
  SHOW_MORE: app_main_wpml.show_more,
  SHOW_ALL: app_main_wpml.show_all,
  DEPARTURE: app_main_wpml.departure,
  DESTINATION: app_main_wpml.destination,
  LOCALITY: app_main_wpml.locality,
  REVIEWS: app_main_wpml.reviews,
  ACTIVITY_DATE: app_main_wpml.activity_date,
  VERIFIED_REVIEWS: app_main_wpml.verified_reviews,
  SHOW_MORE_TEXT: app_main_wpml.show_more_text,
  COMMUNITY_MEDIA: app_main_wpml.community_media,
  MOST_RELEVANT: app_main_wpml.most_relevant,
  MOST_RECENT: app_main_wpml.most_recent,
  LESS_RECENT: app_main_wpml.less_recent,
  HIGHEST_RATED: app_main_wpml.highest_rated,
  LOWEST_RATED: app_main_wpml.lowest_rated,
  REPORT: app_main_wpml.report,
  SHOW_LESS: app_main_wpml.show_less,
  VERIFIED_MEANING_QUESTION: app_main_wpml.verified_meaning_question,
  VERIFIED_MEANING_ANSWER: app_main_wpml.verified_meaning_answer,
  THIS_ACTIVITY_HAS_NO_REVIEWS: app_main_wpml.this_activity_has_no_reviews,
  BE_THE_FIRST_TO_REVIEW: app_main_wpml.be_the_first_to_review,
  REQUIRED_FIELD: app_main_wpml.required_filed,
  FILE_ALERT: app_main_wpml.file_alert,
  FILE_GENERIC_ALERT: app_main_wpml.file_generic_alert,
  FILE_LENGTH_ALERT: app_main_wpml.file_length_alert,
  FILE_TYPE_ALERT: app_main_wpml.file_type_alert,
  UPLOADING: app_main_wpml.uploading,
  UNEXPECTED_ERROR: app_main_wpml.unexpected_error,
  REVIEW_SENT: app_main_wpml.review_sent,
  REVIEW_THANKS: app_main_wpml.review_thanks,
  REVIEW_ERROR: app_main_wpml.review_error,
  DISCOVER_ACTIVITIES: app_main_wpml.discover_activities,
  SHARE: app_main_wpml.share,
  RETRY_NOW: app_main_wpml.retry_now,
  ADD_REVIEW: app_main_wpml.add_review,
  COMPLETE_REVIEW: app_main_wpml.complete_review,
  EDIT: app_main_wpml.edit,
  EDIT_REVIEW: app_main_wpml.edit_review,
  YOU_STILL_HAVE: app_main_wpml.you_still_have,
  DAYS_TO_EDIT_REVIEW: app_main_wpml.days_to_edit_review,
  MEDIA_MAX: app_main_wpml.media_max,
  NO_ONE: app_main_wpml.no_one,
  COUPLE: app_main_wpml.couple,
  FRIENDS: app_main_wpml.friends,
  FAMILY: app_main_wpml.family,
  CO_WORKERS: app_main_wpml.co_workers,
  UPLOAD_MEDIA: app_main_wpml.upload_media,
  WITH_WHOM: app_main_wpml.with_whom,
  TITLE_REVIEW: app_main_wpml.title_review,
  PEOPLE: app_main_wpml.people,
  TIME: app_main_wpml.time,
  MIN_AGE: app_main_wpml.min_age,
  MIN_AGE_PARTICIPANTS: app_main_wpml.min_age_participants,
  YEAR: app_main_wpml.year,
  YEARS: app_main_wpml.years,
  INSERT_NUMBER: app_main_wpml.insert_number,
  GENDER: app_main_wpml.gender,
  PHONE: app_main_wpml.phone,
  WEBSITE: app_main_wpml.website,
  PASSWORD: app_main_wpml.password,
  BUSINESS_NAME: app_main_wpml.business_name,
  LEGAL_CLASSIFICATION: app_main_wpml.legal_classification,
  INDIVIDUAL_COMPANY: app_main_wpml.individual_company,
  COMPANY: app_main_wpml.company,
  ASSOCIATION: app_main_wpml.association,
  FROM: app_main_wpml.from,
  CHECK_PREVIEW: app_main_wpml.check_preview,
  VOUCHER_EXAMPLE: app_main_wpml.voucher_example,
  VOUCHER_HINT: app_main_wpml.voucher_hint,
  VOUCHER_HINT_2: app_main_wpml.voucher_hint_2,
  TAX_ID: app_main_wpml.tax_id,
  VAT_NUMBER: app_main_wpml.vat_number,
  VAT_NUMBER_EXTENDED: app_main_wpml.vat_number_extended,
  VAT_NUMBER_ES: app_main_wpml.vat_number_es,
  REGISTRATION_COMPLETE: app_main_wpml.registration_complete,
  PARTNER_REGISTRATION_COMPLETE: app_main_wpml.partner_registration_complete,
  FOUNDATION: app_main_wpml.foundation,
  EMAIL: app_main_wpml.email,
  EMAIL_ERROR: app_main_wpml.email_error,
  EMAIL_ERROR_MISSING_AT: app_main_wpml.email_error_missing_at,
  EMAIL_ERROR_LENGTH: app_main_wpml.email_error_length,
  EMAIL_ERROR_SPECIAL_CHARS: app_main_wpml.email_error_special_chars,
  EMAIL_ERROR_ONE_PERIOD: app_main_wpml.email_error_one_period,
  EMAIL_ERROR_TDL: app_main_wpml.email_error_tdl,
  EMAIL_ERROR_SPACES: app_main_wpml.email_error_spaces,
  EMAIL_ADDRESS_WARNING: app_main_wpml.email_address_warning,
  FORM_SENT: app_main_wpml.form_sent,
  FORM_SENT_NOTICE: app_main_wpml.form_sent_notice,
  FORM_ERROR: app_main_wpml.form_error,
  FORM_ERROR_NOTICE: app_main_wpml.form_error_notice,
  ACCOUNT: app_main_wpml.account,
  PROFILE_CHANGED: app_main_wpml.profile_changed,
  PROFILE_CHANGED_NOTICE: app_main_wpml.profile_changed_notice,
  UPLOAD_PHOTO: app_main_wpml.upload_photo,
  DELETE_PHOTO: app_main_wpml.delete_photo,
  OFFICIAL_MEDIA: app_main_wpml.official_media,
  COMMUNITY_MEDIA: app_main_wpml.community_media,
  COUPON_APPLIED_CORRECTLY: app_main_wpml.coupon_applied_correctly,
  COUPON_APPLIED_CORRECTLY_AB: app_main_wpml.coupon_applied_correctly_ab,
  GIFTCARD_APPLIED_CORRECTLY: app_main_wpml.giftcard_applied_correctly,
  COUPON_REMOVED_CORRECTLY: app_main_wpml.coupon_removed_correctly,
  LEGAL_INFO_ACTIVITY: app_main_wpml.legal_info_activity,
  THIS_ACTIVITY_IS_OFFERED_BY: app_main_wpml.this_activity_is_offered_by,
  LEGAL_INFO_DESCRIPTION: app_main_wpml.legal_info_description,
  ORDER_ID: app_main_wpml.order_id,
  CANCEL: app_main_wpml.cancel,
  CONTINUE: app_main_wpml.continue,
  CONFIRM: app_main_wpml.confirm,
  VOUCHER_VALUE: app_main_wpml.voucher_value,
  SENDING_REQUEST: app_main_wpml.sending_request,
  PROCESSING: app_main_wpml.processing,
  OUTCOME: app_main_wpml.outcome,
  OPTIONS: app_main_wpml.options,
  CHANGE_ACTIVITY: app_main_wpml.change_activity,
  CANCEL_VOUCHER: app_main_wpml.cancel_voucher,
  ACTIVITY_CHANGE_REQUEST: app_main_wpml.activity_change_request,
  ACTIVITY_CANCEL_REQUEST: app_main_wpml.activity_cancel_request,
  RESEND_PURCHASE_EMAIL: app_main_wpml.resend_purchase_email,
  DOWNLOAD_VOUCHER: app_main_wpml.download_voucher,
  DOWNLOAD_GIFTCARD: app_main_wpml.download_giftcard,
  UNEXPECTED_ERROR_HAS_OCCURRED_PLEASE_RETRY_LATER:
    app_main_wpml.unexpected_error_has_occurred_please_retry_later,
  EMAIL_RESEND_FAILED_MESSAGE: app_main_wpml.email_resend_failed_message,
  CHANGE_VOUCHER_INSTRUCTIONS: app_main_wpml.change_voucher_instructions,
  CANCEL_VOUCHER_INSTRUCTIONS: app_main_wpml.cancel_voucher_instructions,
  CHANGE_ACTIVITY_REQUEST_HAS_BEEN_SUCCESSFULLY_SUBMITTED:
    app_main_wpml.change_activity_request_has_been_successfully_submitted,
  WE_ARE_PROCESSING_YOUR_REQUEST_IF_SUCCESSFUL_VOUCHER_WILL_BE_CONVERT_TO_GF:
    app_main_wpml.we_are_processing_your_request_if_successful_voucher_will_be_convert_to_gf,
  CANCELLATION_REQUEST_HAS_BEEN_SUCCESSFULLY_SUBMITTED:
    app_main_wpml.cancellation_request_has_been_successfully_submitted,
  PARTNER_WILL_BE_NOTIFIED_AND_WILL_EVALUATE_REQUEST:
    app_main_wpml.partner_will_be_notified_and_will_evaluate_request,
  EMAIL_SENT_SUCCESSFULLY: app_main_wpml.email_sent_successfully,
  WANT_TO_REQUEST_AN_ACTIVITY_CHANGE:
    app_main_wpml.want_to_request_an_activity_change,
  TELL_WHY_YOU_WANT_TO_CANCEL_YOUR_VOUCHER:
    app_main_wpml.tell_why_you_want_to_cancel_your_voucher,
  IF_THE_VOUCHER_IS_ELIGIBLE_WILL_BE_CONVERT_TO_A_EQUAL_GF:
    app_main_wpml.if_the_voucher_is_eligible_will_be_convert_to_a_equal_gf,
  WANT_TO_PROCEED_WITH_VOUCHER_CANCELLATION_REQUEST:
    app_main_wpml.want_to_proceed_with_voucher_cancellation_request,
  BY_CANCELING_THIS_VOUCHER_YOU_WILL_LOSE_THE_OPPORTUNITY_TO_USE_IT:
    app_main_wpml.by_canceling_this_voucher_you_will_lose_the_opportunity_to_use_it,
  YOU_ARE_ABOUT_TO_REQUEST_THE_VOUCHER_PURCHASE_CONFIRMATION_EMAIL:
    app_main_wpml.you_are_about_to_request_the_voucher_purchase_confirmation_email,
  EMAIL_WILL_BE_SENT_TO_THE_ADDRESS:
    app_main_wpml.email_will_be_sent_to_the_address,
  IF_THE_EMAIL_IS_WRONG: app_main_wpml.if_the_email_is_wrong,
  OFFER_GIFTCARD: app_main_wpml.offer_giftcard,
  RETHINKING_OR_CHANGING_PREFERENCES_ABOUT_THE_ACTIVITY:
    app_main_wpml.rethinking_or_changing_preferences_about_the_activity,
  ERROR_IN_VOUCHER_PURCHASE: app_main_wpml.error_in_voucher_purchase,
  GIFT_NO_LONGER_SUITABLE_FOR_THE_RECIPIENT:
    app_main_wpml.gift_no_longer_suitable_for_the_recipient,
  PERSONAL_UNFORESEEN_EVENTS: app_main_wpml.personal_unforeseen_events,
  HEALTH_PROBLEMS_OR_PHYSICAL_LIMITATIONS_ARISEN:
    app_main_wpml.health_problems_or_physical_limitations_arisen,
  A_MORE_ADVANTAGEOUS_OFFER_FOUND:
    app_main_wpml.a_more_advantageous_offer_found,
  OTHER: app_main_wpml.other,
  TELL_US_YOUR_MOTIVATION: app_main_wpml.tell_us_your_motivation,
  CANT_FIND_EMAIL: app_main_wpml.cant_find_email,
  IN_SPAM: app_main_wpml.in_spam,
  CHECK_YOUR_EMAIL: app_main_wpml.check_your_email,
  CANT_FIND_EMAIL_AB: app_main_wpml.cant_find_email_ab,
  IN_SPAM_AB: app_main_wpml.in_spam_ab,
  CHECK_YOUR_EMAIL_AB: app_main_wpml.check_your_email_ab,
  ACTIVITY_CHANGE_REQUEST_STATUS: app_main_wpml.activity_change_request_status,
  CANCELLATION_REQUEST_STATUS: app_main_wpml.cancellation_request_status,
  TRANSFORM_TO_VOUCHER_REQUEST_STATUS:
    app_main_wpml.transform_to_voucher_request_status,
  REFUND_REQUEST_STATUS: app_main_wpml.refund_request_status,
  YOU_HAVE_ALREADY_REQUEST_TO_RESEND_THE_EMAIL:
    app_main_wpml.you_have_already_request_to_resend_the_email,
  RADIO_LIST_ERROR: app_main_wpml.radio_list_error,
  MOTIVATION_ERROR: app_main_wpml.motivation_error,
  INSERT_MESSAGE: app_main_wpml.insert_message,
  WE_ARE_SORRY_YOUR_ADVENTURE_DID_NOT_GO_AS_PLANNED:
    app_main_wpml.we_are_sorry_your_adventure_did_not_go_as_planned,
  HELP_US_BETTER_UNDERSTAND_WHAT_HAPPENED_PLEASE_SELECT_THE_REASON:
    app_main_wpml.help_us_better_understand_what_happened_please_select_the_reason,
  ACTIVITY_WAS_CANCELLED_DUE_TO_THE_WEATHER:
    app_main_wpml.activity_was_cancelled_due_to_the_weather,
  ACTIVITY_DOES_NOT_MATCH_THE_DESCRIPTION:
    app_main_wpml.activity_does_not_match_the_description,
  GUIDE_DID_NOT_SHOW_UP: app_main_wpml.guide_did_not_show_up,
  WE_APPRECIATE_YOUR_FEEDBACK_EVERY_REPORT_HELPS_US_IMPROVE:
    app_main_wpml.we_appreciate_your_feedback_every_report_helps_us_improve,
  RESCHEDULE_YOUR_ADVENTURE: app_main_wpml.reschedule_your_adventure,
  CHOOSE_A_NEW_DATE_BASED_ON_YOUR_AVAILABILITY:
    app_main_wpml.choose_a_new_date_based_on_your_availability,
  GET_A_VOUCHER: app_main_wpml.get_a_voucher,
  WANT_TO_RESCHEDULE_CONVERT_YOUR_BOOKING_INTO_A_VOUCHER:
    app_main_wpml.want_to_reschedule_convert_your_booking_into_a_voucher,
  REQUEST_REFUND: app_main_wpml.request_refund,
  WOULD_YOU_PREFER_THE_MONEY_BACK_PROCEED_WITH_THE_REFUND:
    app_main_wpml.would_you_prefer_the_money_back_proceed_with_the_refund,
  REFUND_REQUEST: app_main_wpml.refund_request,
  VOUCHER_REQUEST: app_main_wpml.voucher_request,
  GIFTCARD_REQUEST: app_main_wpml.giftcard_request,
  RECOMMENDED_OPTION: app_main_wpml.recommended_option,
  SOMETIMES_A_SECOND_ATTEMPT_IS_ENOUGH_CHOOSE_ONE_OF_THE_OPTIONS:
    app_main_wpml.sometimes_a_second_attempt_is_enough_choose_one_of_the_options,
  REFUND_INSTRUCTIONS: app_main_wpml.refund_instructions,
  RECAP_OF_THE_REFUND_REQUEST_CONFIRM_THE_FOLLOWING_DETAILS:
    app_main_wpml.recap_of_the_refund_request_confirm_the_following_details,
  YOUR_REFUND_REQUEST_HAS_BEEN_SUCCESSFULLY_SUBMITTED:
    app_main_wpml.your_refund_request_has_been_successfully_submitted,
  RESCHEDULE_THE_ACTIVITY: app_main_wpml.reschedule_the_activity,
  HOW_DOES_THE_REFUND_REQUEST_WORK:
    app_main_wpml.how_does_the_refund_request_work,
  SELECT_A_DATE: app_main_wpml.select_date,
  WHEN_WOULD_YOU_LIKE_TO_DO_THE_ACTIVITY:
    app_main_wpml.when_would_you_like_to_do_the_activity,
  HOW_IT_WORKS_THE_DATE_CHANGE: app_main_wpml.how_it_works_the_date_change,
  DATE_CHANGE_REQUEST_SUMMARY: app_main_wpml.date_change_request_summary,
  TO_BE_REFUNDED: app_main_wpml.to_be_refunded,
  TOTAL_TO_BE_REFUNDED: app_main_wpml.total_to_be_refunded,
  NEW_DATE_REQUESTED: app_main_wpml.new_date_requested,
  MOTIVATION: app_main_wpml.motivation,
  REQUEST_BOOKING_TO_VOUCHER: app_main_wpml.request_booking_to_voucher,
  BOOKING_TO_VOUCHER: app_main_wpml.booking_to_voucher,
  HOW_DOES_THE_BOOKING_TO_VOUCHER_WORK:
    app_main_wpml.how_does_the_booking_to_voucher_work,
  BOOKING_TO_VOUCHER_REQUEST_SUMMARY:
    app_main_wpml.booking_to_voucher_request_summary,
  EXPIRES_ON: app_main_wpml.expires_on,
  TOTAL: app_main_wpml.total,
  YOUR_BOOKING_TO_VOUCHER_REQUEST_HAS_BEEN_SUCCESSFULLY_SUBMITTED:
    app_main_wpml.your_booking_to_voucher_request_has_been_successfully_submitted,
  SELECTION_REQUIRED: app_main_wpml.selection_required,
  SELECT_TIME: app_main_wpml.select_time,
  YOUR_DATE_CHANGE_REQUEST_HAS_BEEN_SUCCESSFULLY_SUBMITTED:
    app_main_wpml.your_date_change_request_has_been_successfully_submitted,
  CONTACT_SEND: app_main_wpml.contact_send,
  WRITE_WHAT_IT_IS_ABOUT_AND_WE_WILL_HELP_YOU:
    app_main_wpml.write_what_it_is_about_and_we_will_help_you,
  ENCOUNTERED_PROBLEM_WITH_YOUR_ORDER:
    app_main_wpml.encountered_problem_with_your_order,
  REPORT_PROBLEM: app_main_wpml.report_problem,
  CANCEL_GIFTCARD: app_main_wpml.cancel_giftcard,
  CANCEL_GIFTCARD_REQUEST: app_main_wpml.cancel_giftcard_request,
  WANT_TO_CANCEL_GIFTCARD: app_main_wpml.want_to_cancel_giftcard,
  BY_CANCELLING_THIS_GIFTCARD_YOU_WILL_LOSE_THE_OPPORTUNITY_TO_USE_IT:
    app_main_wpml.by_cancelling_this_giftcard_you_will_lose_the_opportunity_to_use_it,
  CANCEL_GIFTCARD_INSTRUCTIONS: app_main_wpml.cancel_giftcard_instructions,
  ERROR_IN_GIFTCARD_PURCHASE: app_main_wpml.error_in_giftcard_purchase,
  CANCEL_GIFTCARD_REQUEST_HAS_BEEN_SUCCESSFULLY_SUBMITTED:
    app_main_wpml.your_cancel_giftcard_request_has_been_successfully_submitted,
  QUANTITY: app_main_wpml.quantity,
  WANT_TO_TELL_US_WHY_YOU_WANT_TO_CANCEL:
    app_main_wpml.want_to_tell_us_why_you_want_to_cancel,
  THESE_INFORMATIONS_HELP_US_IMPROVE_OUR_SERVICE:
    app_main_wpml.these_informations_help_us_improve_our_service,
  YOU_ARE_ABOUT_TO_REQUEST_THE_PURCHASE_CONFIRMATION_EMAIL:
    app_main_wpml.you_are_about_to_request_the_purchase_confirmation_email,
  CONFIRM_EMAIL_SENT: app_main_wpml.confirm_email_sent,
  DO_YOU_REALLY_WANT_TO_STOP_THE_REQUEST:
    app_main_wpml.do_you_really_want_to_stop_the_request,
  CONFIRM_CANCELLATION: app_main_wpml.confirm_cancellation,
  YES_CANCEL: app_main_wpml.yes_cancel,
  NO_CONTINUE: app_main_wpml.no_continue,
  CANCEL_RESERVATION: app_main_wpml.cancel_reservation,
  DONT_GIVE_UP_DISCOVER_OUR_ALTERNATIVES:
    app_main_wpml.dont_give_up_discover_our_alternatives,
  GET_A_GIFT_CARD: app_main_wpml.get_a_gift_card,
  CONVERT_YOUR_BOOKING_INTO_A_GIFT_CARD_VALID_18_MONTHS:
    app_main_wpml.convert_your_booking_into_a_gift_card_valid_18_months,
  BY_PROCEEDING_WITH_THE_CANCELLATION_THE_AMOUNT_WILL_NOT_BE_CHARGED:
    app_main_wpml.by_proceeding_with_the_cancellation_the_amount_will_not_be_charged,
  CANCELLATION_REQUEST_SUMMARY_YOU_CONFIRM_THE_FOLLOWING_CANCELLATION:
    app_main_wpml.cancellation_request_summary_you_confirm_the_following_cancellation,
  YOUR_REQUEST_TO_CANCEL_THE_ACTIVITY_HAS_BEEN_SUCCESSFULLY_SUBMITTED:
    app_main_wpml.your_request_to_cancel_the_activity_has_been_successfully_submitted,
  YOUR_BOOKING_TO_VOUCHER_REQUEST_WAS_SUCCESSFUL:
    app_main_wpml.your_booking_to_voucher_request_was_successful,
  HOW_IT_WORKS_RESCHEDULE_ON_HOLD:
    app_main_wpml.how_it_works_reschedule_on_hold,
  REQUEST_TRANSFORMATION_INTO_GIFT_CARD:
    app_main_wpml.request_transformation_into_gift_card,
  DO_YOU_CONFIRM_THE_TRANSFORMATION_INTO_A_GIFT_CARD:
    app_main_wpml.do_you_confirm_the_transformation_into_a_gift_card,
  GIFT_CARD_VALID_18_MONTHS: app_main_wpml.gift_card_valid_18_months,
  TRANSFORMATION_INTO_GIFT_CARD: app_main_wpml.transformation_into_gift_card,
  GIFT_CARD_CONVERSION_REQUEST_WAS_SUCCESSFUL:
    app_main_wpml.gift_card_conversion_request_was_successful,
  IF_CANCELLED_POLICIES_WILL_BE_APPLIED:
    app_main_wpml.if_cancelled_policies_will_be_applied,
  CONFIRM_THE_CANCELLATION_REQUEST_FOR_THE_ACTIVITY:
    app_main_wpml.confirm_the_cancellation_request_for_the_activity,
  REFUND_POLICY: app_main_wpml.refund_policy,
  CANCELLATION_POLICIES_APPLIED: app_main_wpml.cancellation_policies_applied,
  REPORTS_A_PROBLEM: app_main_wpml.reports_a_problem,
  FEEDBACK_RECEIVED: app_main_wpml.feedback_received,
  TRANSFORM_TO_GIFTCARD: app_main_wpml.transform_to_giftcard,
  TRANSFORM_TO_VOUCHER: app_main_wpml.transform_to_voucher,
  SELECTED_DATE_REQUIRES_REFUND: app_main_wpml.selected_date_requires_refund,
  SELECTED_DATE_REQUIRES_EXTRA_CHARGE:
    app_main_wpml.selected_date_requires_extra_charge,
  CHARGE: app_main_wpml.charge,
  REFUND: app_main_wpml.refund,
  ONSITE_PAYMENT: app_main_wpml.onsite_payment,
  JUST_SUBMITTED_WITHDRAWAL_REQUEST:
    app_main_wpml.just_submitted_withdrawal_request,
  IN_PROCESSING: app_main_wpml.in_processing,
  REQUEST_IN_APPROVAL_PHASE_48_HOURS:
    app_main_wpml.request_in_approval_phase_48_hours,
  REQUEST_IN_APPROVAL_PHASE_72_HOURS:
    app_main_wpml.request_in_approval_phase_72_hours,
  WILL_RECEIVE_EMAIL_WITH_THE_RESULT:
    app_main_wpml.will_receive_email_with_the_result,
  REFUSED_CANCELLATION: app_main_wpml.refused_cancellation,
  APPROVED_REQUEST: app_main_wpml.approved_request,
  PENDING_ACTIVITY_CHANGE: app_main_wpml.pending_activity_change,
  PENDING_ACTIVITY_CHANGE_DETAILS:
    app_main_wpml.pending_activity_change_details,
  VOUCHER_GIFT: app_main_wpml.voucher_gift,
  CONFIRMED_VOUCHER_DESCRIPTION: app_main_wpml.confirmedVoucherDescription,
  PENDING_CANCELLATION: app_main_wpml.pending_cancellation,
  PENDING_CANCELLATION_DETAILS: app_main_wpml.pending_cancellation_details,
  CANCELLED_LABEL: app_main_wpml.cancelledLabel,
  RESCHEDULE_ACTIVITY_REQUEST: app_main_wpml.reschedule_activity_request,
  DEFINED_REQUEST_DETAILS: app_main_wpml.defined_request_details,
  REQUEST_REJECTED: app_main_wpml.request_rejected,
  RESCHEDULE_ACTIVITY: app_main_wpml.reschedule_activity,
  DATE_CHANGE_PROCEDURE_IN_PROGRESS_48H:
    app_main_wpml.date_change_procedure_in_progress_48h,
  ACTIVITY_COMPLETED: app_main_wpml.activity_completed,
  ACTIVITY_COMPLETED_NEXT_ADVENTURE:
    app_main_wpml.activity_completed_next_adventure,
  ACTIVITY_COMPLETED_CHOOSE_NEXT_ADVENTURE:
    app_main_wpml.activity_completed_choose_next_adventure,
  CONFIRMED: app_main_wpml.confirmed,
  REQUEST_APPROVED_BASED_ON_CHANGES:
    app_main_wpml.request_approved_based_on_changes,
  DEFINED_REFUND_REQUEST_DETAILS: app_main_wpml.defined_refund_request_details,
  REFUND_REJECTED: app_main_wpml.refund_rejected,
  REFUND_IN_PROGRESS: app_main_wpml.refund_in_progress,
  REFUND_PROCEDURE_IN_PROGRESS_72H:
    app_main_wpml.refund_procedure_in_progress_72h,
  REFUNDED: app_main_wpml.refunded,
  ORDER_REFUNDED_AS_REQUESTED: app_main_wpml.order_refunded_as_requested,
  DEFINED_VOUCHER_TRANSFORMATION_DETAILS:
    app_main_wpml.defined_voucher_transformation_details,
  VOUCHER_TRANSFORMATION_REJECTED:
    app_main_wpml.voucher_transformation_rejected,
  VOUCHER_TRANSFORMATION_IN_PROGRESS:
    app_main_wpml.voucher_transformation_in_progress,
  TRANSFORMATION_PROCEDURE_IN_PROGRESS_72H:
    app_main_wpml.transformation_procedure_in_progress_72h,
  BOOKING_CONFIRMED_ENJOY: app_main_wpml.booking_confirmed_enjoy,
  DEFINED_GIFTCARD_TRANSFORMATION_DETAILS:
    app_main_wpml.defined_giftcard_transformation_details,
  GIFTCARD_TRANSFORMATION_REJECTED:
    app_main_wpml.giftcard_transformation_rejected,
  GIFTCARD_TRANSFORMATION_IN_PROGRESS:
    app_main_wpml.giftcard_transformation_in_progress,
  WAITING_FOR_CONFIRMATION: app_main_wpml.waiting_for_confirmation,
  BOOKING_REQUEST_WAITING_GUIDE_CONFIRMATION:
    app_main_wpml.booking_request_waiting_guide_confirmation,
  SUBMITTED_CANCELLATION_REQUEST: app_main_wpml.submitted_cancellation_request,
  ACTIVITY_CANCELLATION_IN_PROGRESS:
    app_main_wpml.activity_cancellation_in_progress,
  ACTIVITY_CANCELLATION_PROCEDURE_IN_PROGRESS:
    app_main_wpml.activity_cancellation_procedure_in_progress,
  REQUEST_PENDING: app_main_wpml.request_pending,
  FINAL_DESCRIPTION_PLACEHOLDER: app_main_wpml.final_description_placeholder,
  REQUEST_REJECTED_STATUS: app_main_wpml.request_rejected_status,
  REQUEST_APPROVED_STATUS: app_main_wpml.request_approved_status,
  PAYMENT_ON_SITE: app_main_wpml.payment_on_site,
  YOU_CAN_PAY_THE_DIFFERENCE_ON_SITE:
    app_main_wpml.you_can_pay_the_difference_on_site,
  DASHBOARD: app_main_wpml.dashboard,
  HOW_TO_GET_TO_THE_MEETING_POINT:
    app_main_wpml.how_to_get_to_the_meeting_point,
  VIEW_THE_MAP: app_main_wpml.view_the_map,

  CLICK_HERE: app_main_wpml.click_here,
  STILL_NEED_HELP: app_main_wpml.still_need_help,
  START_CHAT: app_main_wpml.start_chat,
  SEND_AN_EMAIL: app_main_wpml.send_an_email,
  CALL_CUSTOMER_SERVICE: app_main_wpml.call_customer_service,
  CHAT_IN_REAL_TIME_WITH_OUR_EXPERTS:
    app_main_wpml.chat_in_real_time_with_our_experts,
  WRITE_TO_OUR_TEAM_WE_ARE_HAPPY_TO_HELP_YOU:
    app_main_wpml.write_to_our_team_we_are_happy_to_help_you,
  WE_ARE_AVAILABLE_SEVEN_DAYS_A_WEEK:
    app_main_wpml.we_are_available_seven_days_a_week,
  SEARCH_BY_TOPIC: app_main_wpml.search_by_topic,
  OR_SELECT_A_TOPIC: app_main_wpml.or_select_a_topic,
  BOOKING_ACTIVITY_PRICE: app_main_wpml.booking_activity_price,
  BOOKING_ACTIVITY_PRICE: app_main_wpml.booking_activity_price,
  LOG_IN_TO_MANAGE_YOUR_RESERVATIONS:
    app_main_wpml.log_in_to_manage_your_reservations,

  DO_YOU_HAVE_QUESTIONS: app_main_wpml.do_you_have_questions,
  YOU_DONT_HAVE_ACTIVE_BOOKINGS: app_main_wpml.you_dont_have_active_bookings,
  FAVOURITE_FIND: app_main_wpml.favourite_find,
  SELECT_ORDER_TO_GET_HELP: app_main_wpml.select_order_to_get_help,

  RESULTS_OF_YOUR_SEARCH: app_main_wpml.results_of_your_search,
  SEE_MORE: app_main_wpml.see_more,
  WE_DIDNT_FIND_RESULTS_FOR_YOUR_SEARCH:
    app_main_wpml.we_didnt_find_results_for_your_search,
  NO_RESULTS_FOUND: app_main_wpml.no_result_found,

  RECAP: app_main_wpml.recap,
  TELEPHONE_ASSISTANCE: app_main_wpml.telephone_assistance,
  TELEPHONE_SUPPORT_IS_AVAILABLE_FROM_TO:
    app_main_wpml.telephone_support_is_available_from_to,
  CONTACT_US_VIA_CHAT_WE_WILL_ANSWER_YOU:
    app_main_wpml.contact_us_via_chat_we_will_answer_you,
  START_CHAT: app_main_wpml.start_chat,
  TELEPHONE_SUPPORT_IS_CURRENTLY_UNAVAILABLE:
    app_main_wpml.telephone_support_is_currently_unavailable,
  NEED_HELP_OPEN_A_CHAT: app_main_wpml.need_help_open_a_chat,
  WE_ARE_OUT_AT_THE_MOMENT: app_main_wpml.we_are_out_at_the_moment,

  EMAIL_PASSWORD_MODIFICATION_IS_NOT_POSSIBLE:
    app_main_wpml.email_password_modification_is_not_possible,
  DO_YOU_WANT_TO_DELETE_YOUR_ACCOUNT:
    app_main_wpml.do_you_want_to_delete_your_account,
  DO_WE_PART_WAYS: app_main_wpml.do_we_part_ways,
  ACCOUNT_DELETION_CONFIRMATION: app_main_wpml.account_deletion_confirmation,
  ACCOUNT_DELETION_CONFIRMATION_2:
    app_main_wpml.account_deletion_confirmation_2,
  DELETE_ACCOUNT: app_main_wpml.delete_account,
  ACCOUNT_DELETED_TITLE: app_main_wpml.account_deleted_title,
  ACCOUNT_DELETED_DESCRIPTION: app_main_wpml.account_deleted_description,
  SOMETHING_WENT_WRONG: app_main_wpml.something_went_wrong,
  TRY_AGAIN_LATER: app_main_wpml.try_again_later,

  FAQ: app_main_wpml.faq,
  CONTACT_THE_GUIDE: app_main_wpml.contact_the_guide,
  FIRST_NAME: app_main_wpml.first_name,
  CALL: app_main_wpml.call,
  WRITE_EMAIL: app_main_wpml.write_email,
  VIEW_MORE_OPTIONS: app_main_wpml.view_more_options,
  SELECT_ORDER: app_main_wpml.select_order,
  PRICE_UP: app_main_wpml.price_up,
  PRICE_DOWN: app_main_wpml.price_down,

  INVALID_VAT_NUMBER: app_main_wpml.invalid_vat_number,
  VAT_NUMBER_REQUIRED: app_main_wpml.vat_number_required,

  GIFTCARD_TITLE: app_main_wpml.gift_card_title,
  GIFTCARD_DESCRIPTION: app_main_wpml.giftcard_description,
  DISCOVER_MORE: app_main_wpml.discover_more,
  GIFTCARD_LINK: app_main_wpml.giftcard_link,
  GIFTCARD_BOX_TITLE: app_main_wpml.giftcard_box_title,
  GIFTCARD_BOX_DESCRIPTION: app_main_wpml.giftcard_box_description,
  GIFTCARD_BOX_CTA: app_main_wpml.giftcard_box_cta,

  DELETE: app_main_wpml.delete,
  DISCOUNT: app_main_wpml.discount,
  EDIT_ORDER: app_main_wpml.edit_order,
  EDIT_DEDICATION: app_main_wpml.edit_dedication,
  TWELVE_MONTHS_VALIDITY: app_main_wpml.twelve_months_validity,
  EIGHTEEN_MONTHS_VALIDITY: app_main_wpml.eighteen_months_validity,
  FROM_PURCHASE_DATE: app_main_wpml.from_purchase_date,
  TAXES_AND_FEES_INCLUDED: app_main_wpml.taxes_and_fees_included,
  FREE_CANCELLATION: app_main_wpml.free_cancellation,
  CANCELLATION_DEADLINE: app_main_wpml.cancellation_deadline,
  LOGIN_WITH_EMAIL: app_main_wpml.login_with_email,
  FIRST_NAME_REQUIRED: app_main_wpml.first_name_required,
  LAST_NAME_REQUIRED: app_main_wpml.last_name_required,
  EMAIL_INVALID: app_main_wpml.email_invalid,
  PASSWORD_INVALID: app_main_wpml.password_invalid,
  PHONE_INVALID: app_main_wpml.phone_invalid,

  EMPTY_STATE_CTA: app_main_wpml.empty_state_cta,
  HISTORY_EMPTY_TITLE_LEAD: app_main_wpml.history_empty_title_lead,
  HISTORY_EMPTY_TITLE_REST: app_main_wpml.history_empty_title_rest,
  HISTORY_EMPTY_TEXT: app_main_wpml.history_empty_text,
  ORDERS_EMPTY_TITLE_LEAD: app_main_wpml.orders_empty_title_lead,
  ORDERS_EMPTY_TITLE_REST: app_main_wpml.orders_empty_title_rest,
  ORDERS_EMPTY_TEXT: app_main_wpml.orders_empty_text,
};
